import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { ManufacturingOrderNotification } from '../manufacturing-order-notification';

export class ManufacturingOrderNotificationBuilder {
  static fromJson(json) {
    return (json)
      ? new ManufacturingOrderNotification(
        json.hash,
        parseNumber(json.notificationDate),
        json.comment,
        json.userHash,
        json.userName,
        json.receivers,
        json.type,
        json.claimedDate,
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ManufacturingOrderNotificationBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order-notification.builder.ts